import { atom, AtomEffect } from 'recoil';
import { PubSub } from './PubSub';

/**
 * High order function that creates atom with subscription side effect
 * It allows to manage atom state outside of react components
 *
 * @param PubSubObject     instance of PubSub class
 * @param atomKey          unique name for atom
 *
 */
export const createAtomWithSubscription = <T>(PubSubObject: PubSub<T>, atomKey: string) => {
  const subscriptionEffect: AtomEffect<T | undefined> = ({ setSelf, trigger }) => {
    const subscriber = (data: T) => {
      setSelf(data);
    };

    if (trigger === 'get') {
      setSelf(PubSubObject.get());
    }

    PubSubObject.subscribe(subscriber);

    return () => {
      PubSubObject.unsubscribe(subscriber);
    };
  };

  const atomWithSubscription = atom<T | undefined>({
    key: atomKey,
    default: undefined,
    effects: [subscriptionEffect],
  });

  return atomWithSubscription;
};
